import { RouterProvider } from 'react-router/dom';
// import useAuth from './hooks/useAuth/index.js';
import { notifications, Notifications } from '@mantine/notifications';
import LoadingBar from 'react-top-loading-bar';
import router from './routes';
import useLoadingBar, { LoadingBarProgressContextType } from '@contexts/useLoadingBar/useLoadingBar';
import { useTour } from '@contexts/useTour/useTour';
import { useEffect } from 'react';
import { useActiveFeatureFlags } from '@infrastructure/featureFlags';
import { useMediaQuery } from '@mantine/hooks';
import { IconExclamationCircle } from '@tabler/icons-react';
import { ThemeDebug } from './styles/themeDebug';
import { ImpersonationBanner } from '@contexts/useAuth/ImpersonationBanner';
import { SuspensionBanner } from '@contexts/useAuth/SuspensionBanner';

function App() {
  // const { user } = useAuth();
  const { barProgress, setLoadingBarProgress } = useLoadingBar() as LoadingBarProgressContextType;
  const { startTour, getTourStatus, activeTour } = useTour();
  const activeFlags = useActiveFeatureFlags();
  const isDesktop = useMediaQuery( '(min-width: 768px)' );
  //TODO:
  // useEffect(() => {
  //   if ( isDesktop && activeFlags.length > 0 && !getTourStatus( 'initial' ) && ( !activeTour || activeTour === 'initial' )) {
  //     startTour( 'initial' );
  //   }
  // }, [ startTour, getTourStatus ]);

  return (
    <div>
      <LoadingBar color={'var(--mantine-primary-color-4)'} height={3} progress={barProgress} onLoaderFinished={() => setLoadingBarProgress( 0 )} />
      <Notifications />
      <ImpersonationBanner />
      <SuspensionBanner />
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
